export default "__VITE_ASSET__Du9JfgnI__"